import { render, staticRenderFns } from "./ProductColumnManage.vue?vue&type=template&id=1f17f45b&scoped=true"
import script from "./ProductColumnManage.vue?vue&type=script&lang=js"
export * from "./ProductColumnManage.vue?vue&type=script&lang=js"
import style0 from "./ProductColumnManage.vue?vue&type=style&index=0&id=1f17f45b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f17f45b",
  null
  
)

export default component.exports